import React from "react";

const BlogPageShell = ({ children }) => (
  <div className="relative min-h-screen overflow-hidden">
    <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-stone-50 via-amber-50/50 to-white" />
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_-10%,rgba(251,191,36,0.18),transparent)]" />
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_40%_at_100%_100%,rgba(245,158,11,0.1),transparent)]" />
    <div className="pointer-events-none absolute -top-32 left-[10%] h-[28rem] w-[28rem] rounded-full bg-yellow-200/25 blur-3xl" />
    <div className="pointer-events-none absolute top-[40%] -right-20 h-80 w-80 rounded-full bg-amber-100/40 blur-3xl" />
    <div className="pointer-events-none absolute bottom-0 left-[20%] h-72 w-72 rounded-full bg-yellow-100/30 blur-3xl" />
    <div
      className="pointer-events-none absolute inset-0 opacity-[0.35]"
      style={{
        backgroundImage:
          "linear-gradient(rgba(161,98,7,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(161,98,7,0.04) 1px, transparent 1px)",
        backgroundSize: "72px 72px",
      }}
    />
    <div className="relative z-10">{children}</div>
  </div>
);

export default BlogPageShell;
